import store from "@/store/store.js"
import settings from "@/http/requests/settings"

export default {
  fetch({ commit }) {
    return new Promise((resolve, reject) => {
      settings.fetch().then(response => {
        const sanitizedSettings = {}

        response.data.data.settings.map(({ name, value }) => {
          sanitizedSettings[name] = value
        })

        commit('SET_SETTINGS', sanitizedSettings)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  fetchGlobal({ commit }) {
    return new Promise((resolve, reject) => {
      settings.getGlobalSetting().then(response => {

        commit('SET_INCIDENT_STATUS', response.data.data.settingsGlobal.value)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  update(_, data) {
    return new Promise((resolve, reject) => {
      settings.update(data).then(response => {
        store.dispatch('settings/fetch')
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  updateKeyValue(_, data) {
    return new Promise((resolve, reject) => {
      store.dispatch('setShowLoadingOverlay', false)

      settings.updateKeyValue(data).then(async response => {
        await store.dispatch('settings/fetch')
        store.dispatch('setShowLoadingOverlay', true)
        resolve(response)
      }).catch((error) => {
        store.dispatch('setShowLoadingOverlay', true)
        reject(error)
      })
    })
  },
  updatePassiveBotSchedule(_, data) {
    return settings.updatePassiveBotSchedule(data)
  },
  fetchWppQrCode(_, instanceId) {
    return new Promise((resolve, reject) => {
      settings.fetchWppQrCode(instanceId).then(response => {
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  changeIncidentStatus({ commit }, data) {
    commit('SET_INCIDENT_STATUS', data);
  }
}
